var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "portlet-body" }, [
      _vm._m(1),
      _vm._v(" "),
      _vm.temErros
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c("strong", [_vm._v("Erro:")]),
            _vm._v(" " + _vm._s(_vm.mensagemErro) + "\n    "),
          ])
        : _vm.carregando
        ? _c("div", { staticClass: "text-center loading-area" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x" }),
            _vm._v(" "),
            _c("p", [_vm._v("Carregando saldos...")]),
          ])
        : _vm.documentos.length > 0 || _vm.lotes.length > 0
        ? _c(
            "div",
            [
              _c("div", { staticClass: "info-bar" }, [
                _c("span", { staticClass: "badge badge-primary" }, [
                  _vm._v(_vm._s(_vm.documentos.length) + " documentos"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "badge badge-warning" }, [
                  _vm._v(_vm._s(_vm.lotes.length) + " lotes"),
                ]),
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "titulo-grid" }, [_vm._v("Documentos")]),
              _vm._v(" "),
              _c("recupera-saldos-grid", {
                attrs: { dados: _vm.documentos, "modo-selecao": "single" },
                on: { "linha-selecionada": _vm.selecionarDocumento },
              }),
              _vm._v(" "),
              _c("h4", { staticClass: "titulo-grid" }, [
                _vm._v("\n        Lotes\n        "),
                _vm.documentoSelecionado
                  ? _c("small", [_vm._v("do documento selecionado")])
                  : _c("small", [
                      _vm._v(
                        "de todos os documentos (selecione um documento para filtrar)"
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("recupera-saldos-grid", {
                attrs: {
                  dados: _vm.lotesExibidos,
                  "mostrar-coluna-lote": true,
                  "modo-selecao": "none",
                },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "alert alert-info" }, [
            _c("i", { staticClass: "fa fa-info-circle" }),
            _vm._v(
              " Nenhum registro encontrado com os filtros aplicados.\n    "
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption" }, [
        _c(
          "span",
          { staticClass: "caption-subject font-green-sharp bold uppercase" },
          [_vm._v("\n        Consulta de Reservas e Bloqueios\n      ")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-warning" }, [
      _c("i", { staticClass: "fa fa-exclamation-triangle" }),
      _vm._v(
        "\n      Esta rotina não soma os movimentos de reservas e bloqueios feitos através de\n      soluções desenvolvidas em camada específica ou de cliente. Caso não tenha\n      certeza se possui desenvolvimento específico ou de cliente que gere movimentos\n      de reserva e/ou bloqueio, não utilize esta rotina e entre em contato com o\n      suporte.\n    "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }